module.exports = __webpack_public_path__ + "static/img/low-profile-single-pedestal-with-custom-shaped-sign.d37c749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/pedestals/low-profile-single-pedestal-with-custom-shaped-sign.jpg
// module id = 715
// module chunks = 0